var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("Primary")]),_vm._v(" "),_c('el-form',[_c('el-form-item',{attrs:{"label":"Booking number:"}},[_c('el-input')],1)],1),_vm._v(" "),_c('el-form',{attrs:{"label-position":"left","label-width":"144px"}},[_c('el-form-item',{attrs:{"label":"Booking number:"}},[_c('el-input')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37d6022e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StyleGuidePage.vue
// module id = 392
// module chunks = 1